import { useDispatch, useSelector } from 'react-redux';
import styles from './ToggleSwitch.module.css';
import { addSettingsApplicationRedux } from '../../store/slices/settingsApplicationSlice';

const ToggleSwitch = () => {
  const dispatch = useDispatch();
  const value = useSelector(
    (state) => state.settingsApplication.settingsApplication.fallingSnowflakes,
  );

  const toggleValue = (value) => {
    dispatch(
      addSettingsApplicationRedux({
        key: 'settingsApplication',
        subKey: 'fallingSnowflakes',
        value: !value,
      }),
    );
  };

  return (
    <div className={styles.wrapper}>
      <h4 className={styles.title}>Увімкнути Вимкнути сніжинки</h4>
      <label className={styles.switch}>
        <input
          type="checkbox"
          checked={value}
          onChange={() => toggleValue(value)}
          className={styles.input}
        />
        <span className={styles.slider} />
        <span className={styles.text}>{value ? 'Увімкнено' : 'Вимкнено'}</span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
